import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon } from './icon-utils';

export function UploadCloudIcon({
  className,
  fill,
  height,
  width,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      fill={fill ?? 'none'}
      height={height ?? 57}
      viewBoxDimensions="0 0 58 57"
      width={width ?? 58}
    >
      <g>
        <path
          clipRule="evenodd"
          d="M21.0754 4.77032C24.3041 4.65136 27.5179 5.26591 30.475 6.56776C33.4321 7.86961 36.0555 9.82489 38.1482 12.2866C39.8379 14.2743 41.146 16.5504 42.0129 19H43.25C46.416 19.0021 49.4927 20.0584 51.9916 22.0023C54.4905 23.9462 56.271 26.6669 57.0519 29.7351C57.8328 32.8032 57.5698 36.044 56.3042 38.9461C55.0387 41.8481 52.8428 44.2461 50.0631 45.7615C48.9114 46.3893 47.4689 45.9647 46.841 44.8131C46.2132 43.6614 46.6378 42.2188 47.7895 41.591C49.6426 40.5807 51.1065 38.9821 51.9502 37.0474C52.7939 35.1127 52.9693 32.9521 52.4487 30.9067C51.928 28.8613 50.7411 27.0475 49.0751 25.7515C47.4092 24.4556 45.3591 23.7514 43.2485 23.75H40.2575C39.1748 23.75 38.2291 23.0177 37.9581 21.9695C37.3291 19.5365 36.1567 17.2778 34.5291 15.3631C32.9015 13.4484 30.861 11.9277 28.5611 10.9151C26.2611 9.90256 23.7615 9.42458 21.2503 9.5171C18.739 9.60963 16.2814 10.2703 14.0621 11.4493C11.8429 12.6284 9.91989 14.2952 8.43758 16.3244C6.95528 18.3537 5.95229 20.6925 5.50401 23.1652C5.05574 25.6379 5.17385 28.18 5.84947 30.6005C6.52508 33.0209 7.74062 35.2567 9.4047 37.1398C10.2733 38.1227 10.1806 39.6236 9.19774 40.4922C8.21485 41.3607 6.71394 41.2681 5.84536 40.2852C3.70584 37.8641 2.143 34.9895 1.27435 31.8775C0.405704 28.7655 0.253847 25.497 0.830197 22.3179C1.40655 19.1387 2.69611 16.1316 4.60193 13.5226C6.50775 10.9136 8.98024 8.77052 11.8335 7.25459C14.6868 5.73866 17.8466 4.88928 21.0754 4.77032ZM27.3207 26.8206C28.2481 25.8931 29.7519 25.8931 30.6794 26.8206L40.1794 36.3206C41.1069 37.2481 41.1069 38.7519 40.1794 39.6794C39.2519 40.6069 37.7481 40.6069 36.8207 39.6794L31.375 34.2337V49.875C31.375 51.1867 30.3117 52.25 29 52.25C27.6884 52.25 26.625 51.1867 26.625 49.875V34.2337L21.1794 39.6794C20.2519 40.6069 18.7481 40.6069 17.8207 39.6794C16.8932 38.7519 16.8932 37.2481 17.8207 36.3206L27.3207 26.8206Z"
          fill="#101828"
          fillRule="evenodd"
        />
      </g>
    </SimpleIcon>
  );
}
